<div id="pagetitle">
    <h1 class="wdn-text-hidden">{{pageH1Tag}}</h1>
</div>
<app-confirm-card></app-confirm-card>
<div class="bodyParent" [ngClass]="{'show-card': showUpdateCard}" [hidden]="loading">
    <app-header [hidden]="!settingsService.showHeader"></app-header>
    <router-outlet></router-outlet>
    <app-footer [hidden]="!settingsService.showFooter"></app-footer>
</div>
<div class="loader-align loader-center" *ngIf="loader == 'dizi'" [hidden]="!loading">
    <img class="loader-size" src="assets/{{appName}}/img/dizi-loader.svg" alt="loader">
</div>
<div class="loader-align loader-center" *ngIf="loader == 'tv2z'" [hidden]="!loading">
    <img class="loader-size" src="assets/img/tv2z.svg" alt="loader">
</div>
<div class="loader-align loader-center" *ngIf="loader == 'funroads'" [hidden]="!loading">
    <img class="loader-size" src="assets/{{appName}}/img/funroadsloader.svg" alt="loader">
</div>
<div class="loader-align" *ngIf="loader == 'film1' || loader == 'filmbox'" [hidden]="!loading">
    <ng-lottie (domLoaded)="domLoaded()" width="350px" height="100vh" [options]="options"></ng-lottie>
</div>